import { render } from "./Role.vue?vue&type=template&id=6ebe76c0&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"

import "./Role.vue?vue&type=style&index=0&id=6ebe76c0&scoped=true&lang=css"

import exportComponent from "D:\\work\\lift\\120.78.159.42\\lcJian\\LC特检通\\特检通\\120.78.159.42\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebe76c0"]])

export default __exports__